import Swiper from 'swiper/bundle';

export default () => {
  const homeSlider = document.querySelector('.js-HomeSlider')
  if(homeSlider) {
    const transition_time = homeSlider.dataset.transitionTime;
    new Swiper(homeSlider, {
      slidesPerView: 1, 
      cssMode: true,
      autoplay: {
        delay: transition_time,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".js-Swiper-Pagination",
        clickable: true,
      },
    });
  }

  const newsSliders = document.querySelectorAll('.js-NewsSlider');
  if(newsSliders) {
    newsSliders.forEach(slider => {
      let breakpoint = window.matchMedia( '(max-width:1023px)' );
      breakpoint.addEventListener('change', initNewsSliders);
      initNewsSliders();
      function initNewsSliders() {
        if ( breakpoint.matches === true ) {
          new Swiper(slider, {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 20,
            autoplay: {
              delay: 5000,
            },
            scrollbar: {
              draggable: true,
              el: slider.querySelector(".js-Swiper-Scrollbar"),
              dragSize: 80,
            },
          });
        } 
      }
    });
  }

  const testimonialSliders = document.querySelectorAll('.js-testimonialSlider');
  if(testimonialSliders) {
    testimonialSliders.forEach(slider => {
      new Swiper(slider, {
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1280: { 
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      });
    });
  }

  const gallerySliders = document.querySelectorAll('.js-GallerySlider')
  if(gallerySliders) {
    gallerySliders.forEach(slider => {
      new Swiper(slider, {
        slidesPerView: 1, 
        spaceBetween: 30,
        loop: true,
        scrollbar: {
          draggable: true,
          el: slider.querySelector(".js-Swiper-Scrollbar"),
          // hide: false,
          dragSize: 80,
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: { 
            slidesPerView: 3,
          },
          1536: {
            slidesPerView: 4,
          },
        },
      });

    });
  }

  const verticalSliders = document.querySelectorAll('.js-VerticalSlider');
  if(verticalSliders) {
    verticalSliders.forEach( slider => {
      let titlesSlide = slider.querySelectorAll('.js-TitleSlide');
      let titles = [];
      titlesSlide.forEach(title => {
        titles.push(title.dataset.title);
      });
      new Swiper(slider, {
        direction: "vertical",
        effect: "fade",
        fadeEffect: {
          crossFade: true,
          transformEl: '.Swiper__ItemWrapper',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<div class="Swiper__TitleBullet ' + className + '"> ' + (titles[index]) + ' </div>';
          },
        },
        navigation: { 
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: { 
          0: {
            direction: 'horizontal', 
          },
          1024: {
            direction: 'vertical', 
          },
        },
        on: {
          slideChange: function () {
            slider.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => {
              bullet.classList.remove('fade-in-left');
            });
            slider.querySelector('.swiper-pagination-bullet-active').classList.add('fade-in-left');
          },
        },
      });
    });
  }

  const textSliders = document.querySelectorAll('.js-TextSlider')
  if(textSliders) {
    textSliders.forEach(slider => {
      new Swiper(slider, {
        slidesPerView: 1, 
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 7000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1024: { 
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      });

    });
  }

  const CarouselsSlider = document.querySelectorAll('.js-CarouselSlider');

  const breakpoint_mobile = window.matchMedia( '(min-width: 0px) and (max-width:640px)' );
  const breakpoint_tablet = window.matchMedia( '(min-width: 641px) and (max-width:1024px)' );
  const breakpoint_tablet_horizontal = window.matchMedia( '(min-width: 1024px) and (max-width:1536px)' );
  const breakpoint_desktop = window.matchMedia( '(min-width: 1537px)' );
  let mySwipers = {};

  breakpoint_mobile.addEventListener('change', initCarouselSliders);
  breakpoint_tablet.addEventListener('change', initCarouselSliders);
  breakpoint_tablet_horizontal.addEventListener('change', initCarouselSliders);
  breakpoint_desktop.addEventListener('change', initCarouselSliders);
  initCarouselSliders();

  function initCarouselSliders() {
    CarouselsSlider.forEach( carousel => {
      const card_count = carousel.dataset.cardCount; 
      if ( 
        (breakpoint_mobile.matches === true && card_count > 1 ) || 
        (breakpoint_tablet.matches === true && card_count > 2) || 
        (breakpoint_tablet_horizontal.matches === true && card_count > 3) || 
        (breakpoint_desktop.matches === true && card_count > 4)
      ) {
        enableSwiper(carousel)
      } else {
        disableSwiper(carousel)
      }

    })
  }

  function disableSwiper (el) {
    // check if el id is in mySwipers
    if (mySwipers[el.id]) {
      // if el status is already disabled, do nothing
      if (mySwipers[el.id].status === 'disabled') {
        return
      } 

      // if el status is enabled, destroy and disable it
      mySwipers[el.id].swiper.destroy(true, true);
      mySwipers[el.id].status = 'disabled';
      mySwipers[el.id].swiper = undefined;
    } else {
      // if el id is not in mySwipers, add it and disable it
      mySwipers[el.id] = {
        swiper: undefined,
        status: 'disabled',
      }
    }

    el.classList.add('disable-slider');
  }

  function enableSwiper (el) {
  // check if el id is in mySwipers
    if (mySwipers[el.id] && mySwipers[el.id].status === 'enabled') {
      return
    } else {
      // if el status is disabled, create and enable it
      let newSwiper = new Swiper(el, {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        longSwipesMs: 1000,
        scrollbar: {
          draggable: true,
          el: el.querySelector(".js-Swiper-Scrollbar"),
          dragSize: 80,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          641: {
            slidesPerView: 2,
            centeredSlides: false,
          },
          1025: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1537: {
            slidesPerView: 4,
            centeredSlides: false,
          },
        },
      });

      mySwipers[el.id] = {
        swiper: newSwiper,
        status: 'enabled',
      }
    }

    el.classList.remove('disable-slider');
  }
}
